





























import Vue, { PropType } from 'vue';
import { Image } from '@/modules/image';
import { v4 } from 'uuid';

export default Vue.extend({
  name: 'GImageCropForm',
  props: {
    owner: { type: String as PropType<string>, required: true },
    label: { type: String as PropType<string>, required: true },
    isTag: { type: Boolean as PropType<boolean>, default: false },
    isPublic: { type: Boolean as PropType<boolean>, default: false },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    exclamation: { type: Array as PropType<string[]>, default: () => [] },
    name: { type: String as PropType<string>, default: '' },
    value: { type: Object as PropType<Image>, default: null },
    caution: { type: String as PropType<string>, default: '' },
    aspect: { type: Number, default: null },
    isCircle: { type: Boolean, default: false },
    showDragOver: { type: Boolean, default: false },
    rules: { type: [String, Object] as PropType<string | object>, default: '' },
  },
  computed: {
    vid(): string {
      return `${this.name}:${v4()}`;
    },
    innerValue: {
      get(): Image | null {
        return this.value;
      },
      set(val: Image | null): void {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    validate() {
      (this.$refs.gImageCropFormProvider as any).validate();
    },
  },
});
